import React from "react";
import { useTranslation } from "react-i18next";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import Section from "../Section";
import SectionHeading from "../SectionHeading";
import IconBoxStyle6 from "../IconBox/IconBoxStyle6";
import { pageTitle } from "../../helpers/PageTitle";
import Spacing from "../Spacing";
import SEO from '../SEO';

export default function Pharmacovigilance() {
  const { t } = useTranslation();
  pageTitle(t("pharmacovigilance.pageTitle"));

  const activitiesData = [
    {
      title: t("pharmacovigilance.goal1Title"),
      subTitle: t("pharmacovigilance.goal1Desc"),
      iconUrl: "/images/icons/professional.svg",
    },
    {
      title: t("pharmacovigilance.goal2Title"),
      subTitle: t("pharmacovigilance.goal2Desc"),
      iconUrl: "/images/icons/comprehensive.svg",
    },
    {
      title: t("pharmacovigilance.goal3Title"),
      subTitle: t("pharmacovigilance.goal3Desc"),
      iconUrl: "/images/icons/patient.svg",
    },
    {
      title: t("pharmacovigilance.goal4Title"),
      subTitle: t("pharmacovigilance.goal4Desc"),
      iconUrl: "/images/icons/facilities.svg",
    },
  ];

  return (
    <>
      <SEO title="Farmakovigjilenca" description="Informacione rreth farmakovigjilencës dhe raportimit të efekteve anësore të barnave." url="/pharmacovigilance" />
      <BannerSectionStyle5
        bgUrl="/images/contact/banner_bg.svg"
        imgUrl="/images/banner/banner_1.png"
        title={t("pharmacovigilance.bannerTitle")}
        subTitle={t("pharmacovigilance.bannerSubtitle")}
      />

      {/* Introduction Section */}
      <Section topMd={200} topLg={150} topXl={110}>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <SectionHeading
                title={t("pharmacovigilance.introTitle")}
                center
              />
              <Spacing md="30" lg="20" xl="15" />
              <div className="cs_section_text text-center">
                <p className="cs_fs_20 mb-0">
                  {t("pharmacovigilance.whoDefinition")}
                </p>
              </div>
              <Spacing md="40" lg="30" xl="25" />
              <div className="text-center cs_accent_bg cs_radius_15 p-4">
                <h3 className="cs_fs_24 cs_semibold text-white mb-2">
                  {t("pharmacovigilance.reportingTitle")}
                </h3>
                <p className="cs_fs_18 text-white mb-3">
                  {t("pharmacovigilance.reportingText")}
                </p>
                <a
                  href={`mailto:${t("pharmacovigilance.contactEmail")}`}
                  className="cs_fs_20 cs_semibold text-white"
                  style={{ textDecoration: "underline" }}
                >
                  {t("pharmacovigilance.contactEmail")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </Section>

      {/* Activities Section */}
      <Section
        topMd={175}
        topLg={125}
        topXl={85}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <div className="container">
          <SectionHeading title={t("pharmacovigilance.goalsTitle")} center />
          <Spacing md="72" lg="50" xl="30" />
          <div className="row">
            {activitiesData.map((item, index) => (
              <div className="col-lg-6" key={index}>
                <IconBoxStyle6 {...item} />
                <Spacing md="85" lg="60" xl="35" />
              </div>
            ))}
          </div>
        </div>
      </Section>
    </>
  );
}
